
import { selectPage, vehicleExport } from '@/services/carBacklogMonitoring';
import { selectByTypeCodes } from '@/services/public';
import moment, { utc } from 'moment';
import { message } from 'antd';

const today = new Date();

const params = {
  provinceAreaCode: '',
  centerCode: '',
  startDate: moment(today).add(-2, 'days').format('YYYY-MM-DD'),
  endDate: moment(today).format('YYYY-MM-DD'),
  statisticsHour: null
};

export default {
  namespace: 'carBacklogMonitoring',
  state: {
    searchParams: { ...params },
    dataList: [],
    page: 1,
    pageSize: 20,
    messageInfo: '',
    statisticsHourItems:[]
  },

  effects: {
    *getData({ payload }, { put, call, select }) {
      const carBacklogMonitoring = yield select(({ carBacklogMonitoring }) => carBacklogMonitoring);
      const { searchParams, page, pageSize } = carBacklogMonitoring;
      const {
        provinceArea,
        center,
        statisticsHour,
        startDate,
        endDate,
      } = searchParams;
      const pages = payload?.page ?? page;
      let result = yield call(selectPage, {
        provinceAreaCode: provinceArea?.code || "",
        centerCode: center?.code || "",
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        statisticsHour: statisticsHour,
        page: pages,
        pageSize,
      });
      yield put({
        type: 'updateState',
        payload: {
          dataList: result?.data?.rows || [],
          total: result?.data?.total || 0,
          page: pages,
        },
      });
    },

    *dataExport({ payload }, { call, put, select }) {
      const carBacklogMonitoring = yield select(({ carBacklogMonitoring }) => carBacklogMonitoring);
      const { searchParams, page, pageSize } = carBacklogMonitoring;
      const {
        provinceArea,
        center,
        statisticsHour,
        startDate,
        endDate,
      } = searchParams;
      const pages = payload?.page ?? page;
      let result = yield call(vehicleExport, {
        provinceAreaCode: provinceArea?.code || "",
        centerCode: center?.code || "",
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        statisticsHour: statisticsHour,
        page: pages,
        pageSize,
        columns:payload?.columns,
      });
      try {
        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },

    *getDictData({ payload }, { call, put }) {
      // const data = yield call(selectByTypeCodes, payload);
      // let statisticsHourItems = data?.data?.map(m => {
      //   return {
      //     value: m.dictCode,
      //     label: m.dictName
      //   };
      // }) || []
      // yield put({
      //   type: 'updateState',
      //   payload: {
      //     statisticsHourItems,
      //   },
      // });
      const response = yield call(selectByTypeCodes, payload);
      // console.log("字典数据成功",response);
      let statisticsHourItems = response?.data?.statistics_time || [];
      if (response && response.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            statisticsHourItems: statisticsHourItems,
          },
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
